import { HelpMenu, ResourceMenu } from "@/components/common";
import NavMenu from "@/components/common/nav-menu/nav-menu.vue";
import { Layout, WriterReview } from "@/locales/localeid";
import { store } from "@/store";
import { computed, defineComponent, ref } from "vue";
import { AppHeader, BaseIcon, DrawerHelper, DropdownItem, fmtMsg, LanguagePicker, UserAvatar } from "vue-glcommonui";
import { useRoute, useRouter } from "vue-router";
import { useDeviceSettingModal } from "@/hooks/useDeviceSettingModal";
import { MODULES, vuexName } from "@/store/utils";

export default defineComponent({
  props: {
    title: String,
  },
  components: {
    AppHeader,
    LanguagePicker,
    UserAvatar,
    BaseIcon,
    DrawerHelper,
    DropdownItem,
    ResourceMenu,
    HelpMenu,
    NavMenu,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { toggleModal } = useDeviceSettingModal();
    const testConnectText = computed(() => fmtMsg(Layout.TestConnect));
    const writerReviewText = computed(() => fmtMsg(WriterReview.Title));
    const currentSchoolId = computed(() => store.getters[vuexName(MODULES.TEACHER.GETTERS.GET_CURRENT_SCHOOL_ID)]);
    const isShowWriterReview = computed(() => route.path.includes("teacher"));
    const testDeviceShown = computed(() => route.name !== "ClassSetUp");
    const deviceSettingsModalShown = ref(false);
    const onClickWriterReview = async () => {
      if (isShowWriterReview.value) {
        await router.push(`/teacher/image-view/${currentSchoolId.value}`);
      }
    };
    const isShowNavMenu = computed(() => {
      return route.path.includes("teacher") || route.path.includes("teacher-calendars");
    });
    return {
      onClickWriterReview,
      testConnectText,
      isShowWriterReview,
      writerReviewText,
      isShowNavMenu,
      deviceSettingsModalShown,
      testDeviceShown,
      toggleModal,
    };
  },
});
